import React from 'react'
import ZoneHeadMomentAtd from '../../features/zoneHead/ZoneHeadMomentAtd'

const ZoneHeadMomentAtdPage = () => {
    return <ZoneHeadMomentAtd />
}

export default ZoneHeadMomentAtdPage